$(document).ready(function(){
    // for mobile 
    var mobileWidth = $(window).width();
    if (mobileWidth < 767) {
        $('.item-icon-text-wrap').on('click', function(){
            $(this).next().slideToggle();
            $(this).toggleClass('active');
        })

        $('.mobile-process-items').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            fade: false,
            dots:false,
            asNavFor: '.the-process-items'
          });

          $('.the-process-items').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            asNavFor: '.mobile-process-items',
            dots: true,
            arrows: false,
          });
    }

    // custom style input file 
    var inputs = document.querySelectorAll('.file-input')

    for (var i = 0, len = inputs.length; i < len; i++) {
      customInput(inputs[i])
    }

    function customInput (el) {
      const fileInput = el.querySelector('[type="file"]')
      const label = el.querySelector('[data-js-label]')
        
      fileInput.onchange =
        fileInput.onmouseout = function () {
          if (!fileInput.value) return
          
          var value = fileInput.value.replace(/^.*[\\\/]/, '')
          el.className += ' -chosen'
          label.innerText = value
      }
    }
    
    // video modal 
    $('img.video-play').on('click', function(){
        $('.video_modal').addClass('active');
    })
    $('span.video_close, .video_overly').on('click', function(){
        $('.video_modal').removeClass('active');
    })
    // date picker 

    $('#datepicker').datepicker({
      dateFormat: "dd/mm/yy"
    });

})

